
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import ThemePaging from './ThemePaging'

export default {
    name: 'ThemeList',
    data() {
        return {
            curPage: 1,
            countByPage: 25,
            params: null,
            // totalCount: {
            //   type: Number,
            //   default: 1,
            // },
        }
    },
    computed: {
        ...mapState('theme', ['themeList']),
        setTotalCount() {
            let count = 0
            if (this.themeList) {
                count = this.themeList.totalCount
            }
            return count
        },
    },

    created() {
        this.params = { pageNo: this.curPage, countByPage: this.countByPage }
        this.GET_THEMELIST(this.params)
    },
    methods: {
        ...mapActions('modal', ['SHOW_ALERT']),
        ...mapActions('theme', ['GET_THEMELIST']),
        onClickPage(page) {
            this.curPage = page
            this.params.pageNo = page
            this.GET_THEMELIST(this.params)
        },
        // 테마 디테일 이동
        onClickDetail(code) {
            if (code > 0) {
                this.$router.push(`/Theme/ThemeDB/${code}`)
            } else {
                this.SHOW_ALERT({ content: '해당 테마를 찾지 못했습니다.' })
            }
        },
    },
}
